var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
// icons
import CustomIllustration from "@frameworks/shared-library/assets/images/features/Markets/Pms/custom-Illustration.svg";
// stylesheet
import "./lead-creation.scss";
// components
import { ClientDetails } from "../../components";
import LoginSearch from "./components/LoginSearch";
import actions from "@mainDi/features/AIF-PMS/actions";
function LeadCreation(_a) {
    //
    var clientDetails = useSelector(function (state) { return state.markets.AifPms; }).clientDetails;
    var leadData = useSelector(function (state) { return state.markets.leadservice; }).leadData;
    var toggleLeadSelection = useSelector(function (state) { return state.markets.global; }).toggleLeadSelection;
    var _b = __read(useState(null), 2), selectedLeadId = _b[0], setSelectedLeadId = _b[1];
    var cActions = actions();
    var leadNotFound = useMemo(function () {
        return (leadData === null || leadData === void 0 ? void 0 : leadData.data) ? false : true;
    }, [leadData]);
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    useEffect(function () {
        var _a;
        if (((_a = leadData === null || leadData === void 0 ? void 0 : leadData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var getLeadId = function (data) {
                var found = data.find(function (item) { return item.displayName !== null && item.displayName !== ""; });
                return found ? found.leadId : data[0].leadId;
            };
            setSelectedLeadId(getLeadId(leadData === null || leadData === void 0 ? void 0 : leadData.data));
            cActions.global.selectLeadId(getLeadId(leadData === null || leadData === void 0 ? void 0 : leadData.data));
        }
    }, [leadData === null || leadData === void 0 ? void 0 : leadData.data]);
    var handleSelectClient = function (item) {
        cActions.leadservice.selectLoginSearchData(item);
    };
    var onClickLeadNotFound = function () {
        if (!leadNotFound) {
            cActions.global.toggleLeadSelection(!toggleLeadSelection);
        }
    };
    return (React.createElement("div", { className: "lead-creation-container" },
        React.createElement("div", { className: "top-container" },
            React.createElement(ClientDetails, null),
            (profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) && (React.createElement(LoginSearch, { onSelectClient: handleSelectClient }))),
        (profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) && !!(clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ispansearch) ? (React.createElement("div", { className: "image-container" },
            React.createElement("img", { src: CustomIllustration, className: "" }))) : (React.createElement(React.Fragment, null))));
}
export default LeadCreation;
